import React, { useRef, useEffect } from "react";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Title,
  Tooltip,
  Legend
);

const LineChart = ({ labels, Total, Title, labelTitle }) => {
  const chartRef = useRef(null);

  // Gradient background
  useEffect(() => {
    const chart = chartRef.current;
    if (!chart) return;
    const ctx = chart.ctx;
    const gradient = ctx.createLinearGradient(0, 0, 0, 400);
    gradient.addColorStop(0, "rgba(59, 130, 246, 0.5)"); // blue-500
    gradient.addColorStop(1, "rgba(59, 130, 246, 0.05)");

    chart.data.datasets[0].backgroundColor = gradient;
    chart.update();
  }, [labels, Total]);

  const data = {
    labels,
    datasets: [
      {
        label: labelTitle,
        data: Total,
        borderColor: "rgba(59, 130, 246, 1)", // blue-500
        borderWidth: 2,
        fill: true,
        tension: 0.4, // smooth curve
        pointBackgroundColor: "white",
        pointBorderColor: "rgba(59, 130, 246, 1)",
        pointHoverRadius: 6,
        pointRadius: 4,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        labels: {
          color: "#374151", // gray-700
          font: {
            size: 12,
          },
        },
      },
      title: {
        display: false,
      },
      tooltip: {
        backgroundColor: "#1f2937", // gray-800
        titleColor: "#fff",
        bodyColor: "#fff",
        padding: 10,
        cornerRadius: 6,
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
        ticks: {
          color: "#6b7280", // gray-500
        },
      },
      y: {
        grid: {
          color: "rgba(209, 213, 219, 0.2)", // light gray
        },
        ticks: {
          color: "#6b7280",
        },
      },
    },
  };

  return (
    <div className="bg-white shadow-md rounded-lg p-4 h-[400px] w-full">
      <h4 className="text-lg font-semibold text-gray-800 mb-3">{Title}</h4>
      <Line ref={chartRef} data={data} options={options} />
    </div>
  );
};

export default LineChart;
